import React, { useState } from 'react';

const ButtonCopy = ({ title = "...", text = "..." }) => {
    const [isCopyned, setIsCopyned] = useState(false);

    const getClipBoardMethod = async (text) => {
        if ("clipboard" in navigator) {
            return await navigator.clipboard.writeText(text);
        } else {
            return document.execCommand("copy", true, text);
        }
    }

    const handleCopyned = async () => {
        getClipBoardMethod(text).then(() => {
            setIsCopyned(true);

            setTimeout(() => {
                setIsCopyned(false);
            }, 1500);
        }).catch((error) => {
            console.error(error);
        });
    };

    return (
        <div className="btn_copy_conatiner">
            <span className="btn_copy_title">{title}</span>
            <b className="btn_copy_text">{text}</b>
            <span className="material-symbols-outlined btn_copy_icon" onClick={handleCopyned}>{isCopyned ? "check_circle" : "content_copy"}</span>
        </div>
    );
};

export default ButtonCopy;